<span class="text-base text-navy-80 font-bold">{{ buildTranslationKey('lastPublished') | translate }}:</span>

<span class="text-base text-navy-80 font-normal">{{ lastPublished | localDate: dateFormat }}</span>

<svg-icon
  class="w-7 h-7"
  [src]="hasPendingChanges ? 'not-published' : 'published'"
  [ngbTooltip]="buildTranslationKey(hasPendingChanges ? 'hasChanges' : 'noChanges') | translate"
  [placement]="'top'"
  [autoClose]="true">
</svg-icon>
